export default "__VITE_ASSET__c9326f69__"